(async () => {
  "use strict";

  const html = (strings, ...values) =>
    String.raw({ raw: strings }, ...values.map((v) => String(v)));

  const gridOutputMap = new Map();
  let currentKey = "";
  let fetchQueue = [];

  const section = document.querySelector(".cs-lookup-new");
  const hasFilters = section.dataset.filters === "true";
  const productGrid = section.querySelector(".sl-product-grid");
  const resultCount = section.querySelector(".sl-sort-count p");
  const lengthBadge = section.querySelector(".slength");
  const widthBadge = section.querySelector(".swidth");
  const lengthRadios = section.querySelectorAll('input[name="size-length"]');
  const widthRadios = section.querySelectorAll('input[name="size-width"]');
  lengthRadios.forEach((lr) => lr.addEventListener("change", handleLookup));
  widthRadios.forEach((wr) => wr.addEventListener("change", handleLookup));
  const sortSelect = section.querySelector("#SortBy");
  let currentSortBy = "manual";
  sortSelect.addEventListener("change", (evt) => {
    currentSortBy = evt.target.value;
    const currentOutput = gridOutputMap.get(currentKey);
    const markup = buildMarkup(
      currentOutput.mapped.stock,
      currentOutput.mapped.seconds,
    );
    productGrid.innerHTML = markup.grid;
    resultCount.innerHTML = markup.count;
    if (AOS) {
      AOS.refreshHard();
    }
  });

  const filters = {
    toe: [],
    material: [],
    category: [],
  };
  if (hasFilters) {
    const filterInputs = section.querySelectorAll(
      ".ex-filter-wrapper .tag__input",
    );
    const mobileFilterCount = section.querySelector(".mobile-filter-count");
    filterInputs.forEach((input) =>
      input.addEventListener("change", (evt) => {
        const values = filters[input.name];
        const inValues = values.includes(input.value);
        if (input.checked && !inValues) {
          values.push(input.value);
        } else if (!input.checked && inValues) {
          filters[input.name] = values.filter((val) => val !== input.value);
        }

        const count =
          2 +
          filters.toe.length +
          filters.material.length +
          filters.category.length;
        mobileFilterCount.innerHTML = `(${count})`;

        const currentOutput = gridOutputMap.get(currentKey);
        const markup = buildMarkup(
          currentOutput.mapped.stock,
          currentOutput.mapped.seconds,
        );
        productGrid.innerHTML = markup.grid;
        resultCount.innerHTML = markup.count;
        if (AOS) {
          AOS.refreshHard();
        }
      }),
    );
  }

  const noResultMessage = section.dataset.noResultMessage;

  const SizeFilterDrawer = new theme.Drawers(
    "SLSizeDrawer",
    "sl-size-filters",
    true,
  );

  handleLookup();
  window.on("popstate", onPopState);

  function handleLookup() {
    const length = section.querySelector(
      "input[name='size-length']:checked",
    )?.value;
    const width = section.querySelector(
      "input[name='size-width']:checked",
    )?.value;

    if (!length || !width) return;

    const formData = new FormData();
    formData.set("length", length);
    formData.set("width", width);
    lengthBadge.innerHTML = `Length: ${length}`;
    widthBadge.innerHTML = `Width: ${width}`;
    lengthBadge.classList.remove("hide");
    widthBadge.classList.remove("hide");

    const queryString = new URLSearchParams(formData);
    history.pushState(
      {},
      "",
      `${window.location.pathname}${queryString && "?".concat(queryString)}`,
    );

    formData.set(
      "sdcm_data",
      JSON.stringify(
        typeof sdcm_data !== "undefined" && sdcm_data ? sdcm_data : [],
      ),
    );
    setProductGrid(formData);
  }

  function onPopState(state) {
    if (state) {
      const newUrl = new URL(window.location.href);
      if (newUrl.searchParams.size > 0) {
        const currentParams = new URLSearchParams(window.location.search);
        const formData = new FormData();
        formData.set("length", currentParams.get("length"));
        formData.set("width", currentParams.get("width"));
        formData.set(
          "sdcm_data",
          JSON.stringify(
            typeof sdcm_data !== "undefined" && sdcm_data ? sdcm_data : [],
          ),
        );
        const lengthRadio = document.querySelector(
          `input[name="size-length"][value="${currentParams.get("length")}"]`,
        );
        const widthRadio = document.querySelector(
          `input[name="size-width"][value="${currentParams.get("width")}"]`,
        );
        lengthBadge.innerHTML = `Length: ${currentParams.get("length")}`;
        widthBadge.innerHTML = `Width: ${currentParams.get("width")}`;
        lengthBadge.classList.remove("hide");
        widthBadge.classList.remove("hide");
        if (lengthRadio && widthRadio) {
          lengthRadio.checked = true;
          widthRadio.checked = true;
        }
        setProductGrid(formData);
      }
    }
  }

  async function setProductGrid(formData) {
    productGrid.classList.add("unload");
    const mapKey = `${formData.get("length")} / ${formData.get("width")}`;
    currentKey = mapKey;
    let gridOutput = gridOutputMap.get(mapKey);
    fetchQueue.push(mapKey);

    if (gridOutput) {
      //if grid output then sort it? maybe only do this when sorting is applied?
      gridOutput.markup = buildMarkup(
        gridOutput.mapped.stock,
        gridOutput.mapped.seconds,
      );
    } else if (!gridOutput) {
      try {
        const response = await fetch(
          window.Shopify.routes.root + "apps/jkcustom/stock-lookup",
          {
            method: "POST",
            body: formData,
          },
        );
        if (response.status === 401) throw new Error("no session");
        const body = await response.json();
        gridOutput = buildProductGrid(body.data || body.products, mapKey);
      } catch (err) {
        console.log(err);
        productGrid.innerHTML = html`<div class="message errors">
          <p>We encountered an error looking this size, please try again.</p>
        </div>`;
        productGrid.classList.remove("unload");
      }
    }

    if (gridOutput) {
      productGrid.innerHTML = gridOutput.markup.grid;
      resultCount.innerHTML = gridOutput.markup.count;
      if (AOS) {
        AOS.refreshHard();
      }
      if (fetchQueue[fetchQueue.length - 1] === mapKey) {
        productGrid.classList.remove("unload");
        fetchQueue = [];
      }
    }
  }

  function buildProductGrid({ stock, seconds }, key) {
    const imageSizes = "(min-width: 769px) 20vw, 39vw";

    const mappedProducts = stock.map(mapProduct);
    const mappedSeconds = seconds.map(mapProduct);

    const markup = buildMarkup(mappedProducts, mappedSeconds);

    const gridOutput = {
      markup,
      stockCount: stock.length,
      mapped: {
        stock: mappedProducts,
        seconds: mappedSeconds,
      },
    };
    gridOutputMap.set(key, gridOutput);
    return gridOutput;
  }

  function buildMarkup(stock, seconds) {
    let stockProducts = sortProducts(stock);
    let secondsProducts = sortProducts(seconds);

    if (hasFilters) {
      stockProducts = applyFilters(stockProducts);
      secondsProducts = applyFilters(secondsProducts);
    }

    const limit = 100;
    const secondsMarkup =
      secondsProducts.length > 0
        ? html`<div class="seconds-header">
            <h4>Seconds In Stock</h4>
            <p>
              ${secondsProducts.length}
              Result${secondsProducts.length !== 1 ? "s" : ""}
            </p>
          </div>` +
          secondsProducts
            .slice(0, limit)
            .map((s) => s.markup)
            .join("")
        : "";
    const grid =
      stockProducts.length === 0 && stockProducts.length === 0
        ? html`<div class="message"><p>${noResultMessage}</p></div>`
        : stockProducts
            .slice(0, limit)
            .map((p) => p.markup)
            .join("") + secondsMarkup;

    const count =
      stockProducts.length > 0
        ? `${stockProducts.length} Result${
            stockProducts.length !== 1 ? "s" : ""
          }`
        : "";
    return { grid, count };
  }

  function applyFilters(products) {
    if (!hasFilters) return products;
    return products.filter((product) => {
      const inToe =
        filters.toe.length > 0 ? filters.toe.includes(product.toe) : true;
      const inCategory = filters.category.length
        ? filters.category.some((cat) => product.category.includes(cat))
        : true;
      const inMaterial =
        filters.material.length > 0
          ? filters.material.includes(product.material)
          : true;
      return inToe && inCategory && inMaterial;
    });
  }

  function mapProduct(data, index) {
    const secondsProduct =
      Object.hasOwn(data, "productType") &&
      data.productType === "Custom Seconds Boots";
    const product = secondsProduct ? data : data.product;
    const variant = secondsProduct ? data.variants.nodes[0] : data;
    const url = secondsProduct
      ? `https://jkbootswarehouse.com/products/${product.handle}?cslv=a`
      : `/products/${product.handle}?variant=${variant.id
          .split("/")
          .pop()}&cslv=a`;

    const priceData = getPriceData(variant.price, data);
    const imageMarkup = theme.buildProductImage(
      {
        title: product.title,
        image_responsive_url: theme.Images.buildImagePath(
          product.featuredMedia?.preview.image.url,
        ),
        image_responsive_urls: theme.Images.buildImagePath(
          product.featuredMedia?.preview.image.url,
          [180, 360, 540, 720, 900],
        ),
        image_aspect_ratio: 100,
      },
      "(min-width: 769px) 20vw, 39vw",
    );

    const tagMarkup = secondsProduct
      ? html`<div class="grid-product__tag grid-product__tag--custom">
          Seconds
        </div>`
      : priceData.sale
        ? html`<div class="grid-product__tag grid-product__tag--sale">
            Sale
          </div>`
        : "";
    // <span class="grid-product__price--savings">
    //       Save
    //       <span>${priceData.sale.savings}</span>
    //     </span>
    const priceMarkup = priceData.sale
      ? html`<span class="visually-hidden">Sale price</span>
          <span class="grid-product__price--sale">${priceData.sale.price}</span>
          <span class="visually-hidden">Regular price</span>
          <span class="grid-product__price--original"
            >${priceData.price}</span
          > `
      : priceData.price;
    const shortDescriptionMarkup = product.shortDescription?.value
      ? html`<div class="grid-product__short--description">
          ${product.shortDescription.value}
        </div>`
      : "";

    const material = secondsProduct
      ? product.title.toLowerCase().includes("bison")
        ? "Bison"
        : "Steerhide"
      : product.material?.value;
    const category = secondsProduct
      ? ["Work"]
      : product.category
        ? JSON.parse(product.category.value)
        : [];

    return {
      index,
      id: variant.id,
      title: product.title,
      price: priceData,
      toe: product.toeType?.value,
      category,
      material,
      markup: html`
        <div class="sl-pg-item" data-aos="row-of-4">
          <div class="grid-product__content">
            ${tagMarkup}
            <div class="grid__item-image-wrapper">
              <div class="grid-product__image-mask">${imageMarkup}</div>

              <a href="${url}" class="grid-product__link">
                <div class="grid-product__meta">
                  <div class="grid-product__title grid-product__title--body">
                    ${product.title}
                  </div>
                  ${shortDescriptionMarkup}
                  <div class="grid-product__price">${priceMarkup}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      `,
    };
  }

  function getPriceData(variantPrice, data) {
    const priceNum =
      Shopify.currency.active === "USD"
        ? variantPrice
        : Math.ceil(variantPrice * Shopify.currency.rate);
    const price = theme.Currency.formatMoney(
      priceNum * 100,
      theme.settings.moneyFormat,
    );
    let salePrice, saleSavings, percentSavings;
    if (data.sale_data) {
      const saleData = data.sale_data;
      percentSavings = saleData.savings;
      if (saleData.type === "percentage") {
        const savingPercentage = (100 - saleData.savings) / 100;
        salePrice = Math.ceil(priceNum * savingPercentage * 100) / 100;
        saleSavings = priceNum - salePrice;
      } else {
        saleSavings =
          Shopify.currency.active === "USD"
            ? saleData.savings
            : Math.ceil(saleData.savings * Shopify.currency.rate);
        salePrice = priceNum - saleSavings;
      }
    } else if (
      data.productType === "Custom Seconds Boots" &&
      data.discount?.value
    ) {
      percentSavings = parseFloat(data.discount.value);
      const percentage = percentSavings
        ? Number(100 - percentSavings) / 100
        : null;
      salePrice = Math.ceil(priceNum * percentage * 100) / 100;
      saleSavings = priceNum - salePrice;
    }

    const sale =
      salePrice && saleSavings
        ? {
            priceNum: salePrice,
            price: theme.Currency.formatMoney(
              salePrice * 100,
              theme.settings.moneyFormat,
            ),
            savingsNum: saleSavings,
            savings:
              theme.settings.saveType === "dollar"
                ? theme.Currency.formatMoney(
                    saleSavings * 100,
                    theme.settings.moneyFormat,
                  )
                : `${percentSavings}%`,
          }
        : null;

    return {
      priceNum,
      price,
      sale,
    };
  }

  function sortProducts(products) {
    if (currentSortBy === "title-ascending") {
      return products.sort((a, b) => a.title.localeCompare(b.title));
    } else if (currentSortBy === "title-descending") {
      return products.sort((a, b) => b.title.localeCompare(a.title));
    } else if (currentSortBy.includes("price")) {
      return products.sort((a, b) => {
        const priceA = Number(
          a.price.sale ? a.price.sale.priceNum : a.price.priceNum,
        );
        const priceB = Number(
          b.price.sale ? b.price.sale.priceNum : b.price.priceNum,
        );
        return currentSortBy === "price-ascending"
          ? priceA - priceB
          : priceB - priceA;
      });
    } else {
      return products.sort((a, b) => a.index - b.index);
    }
  }
})();
